// @flow

import { location } from 'window';
import url from 'url';
import Q from 'q';
import $ from 'jquery';
import config from 'config';
import onBeforeUnloadHandler from 'window-onbeforeunload-handler';
import userInfoSpy from 'user-info-spy';

export const EMAIL_INFO_KEY = 'prefilling.email';

function init () {
	const queryParamsReady = Q(url.parse(location.href, true).query);

	const configReady = Q.all([
		config.cms.pageUrls.get(),
		config.cms.siteID.get(),
	])
		.spread((pageUrls, siteID) => {
			return { cms: { pageUrls, siteID } };
		});

	const domReady = Q.promise(resolve => $(resolve));

	return Q.all([
		queryParamsReady,
		configReady,
		domReady,
	])
		.then(([
			query,
			config,
		]) => {
			
			if (query.user) {
				userInfoSpy.set(EMAIL_INFO_KEY, query.user);
			}

			if (location.href.includes('prefilling.wbp')) {
				const redirectUrl = config.cms.pageUrls.currentSite.home;

				onBeforeUnloadHandler.redirectWithoutAlert(redirectUrl);

				return Q.delay(30 * 1000);
			}
		})
		.done();
}

init();
